// Generouted, changes to this file will be overridden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/403`
  | `/auditlogs`
  | `/change-password`
  | `/dashboard`
  | `/house-rentals`
  | `/kpi`
  | `/login`
  | `/register`
  | `/rentals`
  | `/reset`
  | `/settings/business-units`
  | `/settings/external-api`
  | `/settings/permissions`
  | `/settings/tenants`
  | `/settings/transaction-types`
  | `/settings/unitcodes`
  | `/transaction-queries`
  | `/transactions`
  | `/users`

export type Params = {
  
}

export type ModalPath = `/house-rentals/add` | `/house-rentals/delete` | `/house-rentals/edit` | `/house-rentals/property` | `/profile` | `/rentals/add` | `/rentals/delete` | `/rentals/edit` | `/rentals/property` | `/settings/business-units/add` | `/settings/business-units/delete` | `/settings/business-units/edit` | `/settings/tenants/add` | `/settings/tenants/delete` | `/settings/tenants/edit` | `/settings/transaction-types/add` | `/settings/transaction-types/delete` | `/settings/transaction-types/edit` | `/settings/unitcodes/add` | `/settings/unitcodes/delete` | `/settings/unitcodes/edit` | `/transactions/add` | `/transactions/delete` | `/transactions/edit` | `/transactions/image` | `/users/add` | `/users/delete` | `/users/edit`

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
